<template>
  <div class="form-section mt-32">
    <h3 class="section-title">첨부파일 등록</h3>
    <ul class="check-list">
      <li v-for="file in files" :key="file.ATTCH_SEQ">
        <div class="tit">{{ file.ATTCH_FILE_INFO || file.FILE_INFO}}<br></div>
        <div class="file-input-wrapper" v-if="file.REALFILENM !== null && file.REALFILENM !== '' ">
          <!-- <a href="javascript:void(0)" style="cursor:pointer"
            :title="`${file.REALFILENM} 다운로드`"
            @click="fn_fileDown(file.SAVE_FILE_NM, file.REALFILENM)">{{ file.REALFILENM }}</a> -->
          <!-- <input type="file" style="width: 100%;opacity: 0;" :disabled="isDisabled" title="첨부파일 선택">
          <input type="text" :placeholder="placeholder" :value="file.REALFILENM" readonly title=" 입력" />
          <button type="button" class="btn-file-upload">파일추가</button> -->
          <a href="javascript:void(0)" v-if="!isEditMode"
            :style="{ cursor: file.REALFILENM ? 'pointer' : 'text' }"
            @click="downloadFile(file)" title="{{ file.REALFILENM || '-' }}">{{ file.REALFILENM || '-' }}</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AttachmentSection',
  props: {
    annKindType: {
      type: String,
      default: 'IN'
    },
    files: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '파일을 추가해 주세요.'
    }
  },
  methods: {
    downloadFile(file) {
      if (!file || !file.SAVE_FILE_NM) {
        return;
      }

      // 동적 폼 생성
      const vfrm = document.createElement('form');
      vfrm.method = 'post';
      vfrm.target = '_self';
      vfrm.id = 'tempFileForm';
      vfrm.action = '/in_getfileDown.do';

      // 저장된 파일명 input
      const vipinput1 = document.createElement('input');
      vipinput1.setAttribute('type', 'hidden');
      vipinput1.setAttribute('name', 'SAVE_FILE_NM');
      vipinput1.setAttribute('value', file.SAVE_FILE_NM);
      vfrm.appendChild(vipinput1);

      // 실제 파일명 input
      const vipinput2 = document.createElement('input');
      vipinput2.setAttribute('type', 'hidden');
      vipinput2.setAttribute('name', 'REALFILENM');
      vipinput2.setAttribute('value', file.REALFILENM);
      vfrm.appendChild(vipinput2);

      // 폼을 body에 추가하고 submit
      document.body.appendChild(vfrm);
      vfrm.submit();

      // 폼 제거
      document.body.removeChild(vfrm);
    },
  },
};
</script>



// WEBPACK FOOTER //
// AttachmentSection.vue?4f55de0d